import { render, staticRenderFns } from "./SpecialWinner.vue?vue&type=template&id=bd889828&"
import script from "./SpecialWinner.vue?vue&type=script&lang=js&"
export * from "./SpecialWinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports